var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.275055 13.0335C-0.275055 11.121 2.23965 11.121 3.497 9.846C4.12568 9.2085 2.23965 9.2085 2.23965 6.021C2.23965 3.89621 3.07768 2.8335 4.75436 2.8335C6.43104 2.8335 7.26906 3.89621 7.26906 6.021C7.26906 9.2085 5.38303 9.2085 6.01171 9.846C7.26906 11.121 9.78377 11.121 9.78377 13.0335",
    stroke: "#263238",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94113 11.5401C9.41641 11.208 10.0334 10.9688 10.6238 10.6805C11.0854 10.4551 11.5307 10.1995 11.8794 9.846C12.508 9.2085 10.622 9.2085 10.622 6.021C10.622 3.89621 11.46 2.8335 13.1367 2.8335C14.8134 2.8335 15.6514 3.89621 15.6514 6.021C15.6514 9.2085 13.7654 9.2085 14.3941 9.846C15.6514 11.121 18.1661 11.121 18.1661 13.0335",
    stroke: "#263238",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.01e8d81194cc2b9950a41a4d3826e719.svg";
export { ForwardRef as ReactComponent };